import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { IReturnChangesWidgetEditForm, checkIfFieldDisabled, composedOptions, composedTypes, composedTypesAttributes, contentNode, deepCopy, makeid, widgetEditMode } from 'na-lib';
import { SettingsService } from 'src/app/service/settings.service';
import { ComposedEditContentDialogComponent } from '../../editWidgets/composed-edit-content-dialog/composed-edit-content-dialog.component';

@Component({
    selector: 'app-composed-edit-form',
    templateUrl: './composed-edit-form.component.html',
    styleUrl: './composed-edit-form.component.css',
    standalone: false
})

export class ComposedEditFormComponent {
  @Input() data:widgetEditMode;
  @Output() returnChanges = new EventEmitter<IReturnChangesWidgetEditForm>();

  composedEditForm!:FormGroup
  composedEditData:any
  widgetNumber:any
  defaultLanguage:string
  oldData:any
  passId:any
  translationModeOriginal = false
  translationMode = false
  translateFields = []

  oldSchema:any
  allproperties:contentNode[] = []
  TREE_DATA:contentNode[] = []
  treeControl = new NestedTreeControl<contentNode>(node => node?.children  );
  dataSource = new MatTreeNestedDataSource<contentNode>();
  
  composedOptions = composedOptions
  composedTypesAttributes = composedTypesAttributes
  composedTypes = composedTypes

  userHasBetaWidgetRole = false
  
  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
    private settingsService: SettingsService
  ){
  }

  ngOnInit(): void {
    if(this.settingsService.checkIfBetaRoleAccess())
      this.userHasBetaWidgetRole = true
    this.defaultLanguage = this.data.defaultLanguage
    this.composedEditData = deepCopy(this.data.values)
    this.passId = this.data.passId
    this.widgetNumber = this.data.widget
    this.translationMode = this.data.translateMode

    if(this.data.translateMode){
      let translateData = deepCopy(this.data.translateData)
      const {fields, originalLanguageData, defaultLanguageWidgetData, valuesTranslated, selectedLanguage, values} = translateData
      this.translateFields = fields

      if(translateData.originalLanguageData){
        this.translationModeOriginal = true
        this.initTranslateEditData( defaultLanguageWidgetData, valuesTranslated, originalLanguageData, [],selectedLanguage)
      }else{
        this.translationModeOriginal = false
        this.initTranslateEditData(values,valuesTranslated, originalLanguageData, fields, selectedLanguage)
      }
    }
    else
    this.initWidgetEdit()
  }

  initWidgetEdit(){
    const {id, type,filter, subtitle, title,content, name,widgetStyle } = this.composedEditData
    
    this.composedEditForm = this.fb.group({
      id: {value:id ? id : undefined, disabled:false} , 
      type: {value: type ? type : undefined, disabled:false}, 
      subtitle: {value: subtitle ? subtitle : undefined, disabled:false}, 
      title: {value: title ? title : undefined, disabled:false}, 
      name: {value: name ? name : undefined, disabled:false},
      filter: {value: filter ? filter :undefined, disabled: false},
      content: {value: content ? content : undefined, disabled:false},
      widgetStyle:{ value: widgetStyle ? widgetStyle : undefined, disabled:false}
    })

    this.allproperties=content
    if(!content || content?.length ==0)
      this.allproperties=[]

    this.dataSource.data = this.allproperties

    this.composedEditForm.valueChanges.subscribe((value:any)=> {
      this.returnChanges.emit({
        type:"composed",
        form: this.composedEditForm,
        validForm: this.composedEditForm.valid,
        data: value,
        saveDisabled: false
      })
    })
  }

  initTranslateEditData(data, valuesTranslated, originalLanguageData, fields, selectedLanguage){
  
    let {id, type,filter, subtitle, title,content, name,widgetStyle } = data
  
    if(!originalLanguageData){
      title = valuesTranslated[selectedLanguage +'.'+id+'.title']
      subtitle = valuesTranslated[selectedLanguage +'.'+id+'.subtitle']

      content.forEach(element => {
        this.readTranslationsOfContent(element, id, valuesTranslated, selectedLanguage)   
      });
    }

    this.allproperties=content
    if(!content || content?.length ==0)
      this.allproperties=[]

    this.dataSource.data = this.allproperties

    this.composedEditForm = this.fb.group({
      id: {value:id ? id : undefined, disabled: checkIfFieldDisabled('id', fields, originalLanguageData)} , 
      type: {value: type ? type : undefined, disabled: checkIfFieldDisabled('type', fields, originalLanguageData)}, 
      subtitle: {value: subtitle ? subtitle : undefined, disabled: checkIfFieldDisabled('subtitle', fields, originalLanguageData)}, 
      title: {value: title ? title : undefined, disabled: checkIfFieldDisabled('title', fields, originalLanguageData)}, 
      name: {value: name ? name : undefined, disabled: checkIfFieldDisabled('name', fields, originalLanguageData)},
      filter: {value: filter ? filter :undefined, disabled: checkIfFieldDisabled('filter', fields, originalLanguageData)},
      content: {value: content ? content : undefined, disabled: checkIfFieldDisabled('content', fields, originalLanguageData)},
      widgetStyle:{ value: widgetStyle ? widgetStyle : undefined, disabled: checkIfFieldDisabled('widgetStyle', fields, originalLanguageData)}
    })

    this.composedEditForm.valueChanges.subscribe( value => {
      if(!originalLanguageData){
        this.returnChanges.emit({
          type:"composed",
          form: this.composedEditForm,
          validForm: this.composedEditForm.valid,
          translations: {title:value.title, subtitle:value.subtitle, content: value.content },
          saveDisabled: false
        })
      }
    })
  }


  readTranslationsOfContent(element, widgetId, valuesTranslated, selectedLanguage){
    if(element.type == 'zstack' || element.type == 'hstack' || element.type == 'vstack'){
      const children = element.children
      children.forEach(child => {
        this.readTranslationsOfContent(child, widgetId, valuesTranslated, selectedLanguage)
      });
    }

    if(element.attributes && element.attributes.text)
      element.attributes.text = valuesTranslated[selectedLanguage +'.'+ widgetId + '_' + element.id + '_attributes.text']

  }


  refreshTree(){
    let _data = this.dataSource.data;
    this.dataSource.data = [];
    this.dataSource.data = _data;
    this.allproperties = this.dataSource.data
  }

  hasChild = (_: number, node: contentNode) => !!node.children && node.children?.length >= 0;
  isArrayType = (_: number, node: contentNode) => node.type=='vstack' || node.type=='hstack' || node.type=='zstack' || node.children;

  editNodeAttributes(node, index){
    let dialogRef= this.dialog.open(ComposedEditContentDialogComponent, {
      data: {
        translate: this.translationMode,
        translateOriginal : this.translationModeOriginal,
        fields: this.translateFields,
        type:"editNodeAttribute",
        values:node,
        attributesTypes:this.composedTypesAttributes[node.type],
        title: 'pass.composed.' + node.type
      },
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        if(!node.id)
        node.id = makeid(5)
        
        node.attributes = result[1]
        this.composedEditForm.patchValue({content: this.allproperties})
        this.dataSource.data = this.allproperties
        this.refreshTree()
      }
    });
  }


  addChildrenNode(node, composed){
    const newNode = deepCopy(this.composedTypes[composed.value])
    newNode.id = makeid(5)
    if(node.children){
      node.children.push(newNode)
    }else{
      node.children = [ newNode ]
    }
    this.composedEditForm.patchValue({content: this.allproperties})
    this.dataSource.data = this.allproperties
    this.refreshTree()
  }

  addContentNode(composed){
    const newNode = deepCopy(this.composedTypes[composed.value])
    newNode.id = makeid(5)

    if(this.allproperties?.length!=0){
      this.allproperties.push(newNode)
    }else{
      this.allproperties = [ newNode ]
    }
    
    this.composedEditForm.patchValue({content: this.allproperties})
    this.dataSource.data = this.allproperties
    this.refreshTree()
  }


  deleteThisNode(deleteNode: contentNode, allContentNodes: contentNode[] = this.allproperties): void {
    for (let index = 0; index < allContentNodes.length; index++) {
      const node = allContentNodes[index]
      if (node.children)
        this.deleteThisNode(deleteNode, node.children)
  
      if (node === deleteNode) {
        allContentNodes.splice(index, 1); // Remove the node from its parent's children array
        this.composedEditForm.patchValue({content: this.allproperties})
        this.dataSource.data = this.allproperties
        this.refreshTree()
        return;
      }
    }
  }

  deleteAllContent(){
    this.allproperties = []
    this.composedEditForm.patchValue({content: this.allproperties})
    this.dataSource.data = this.allproperties
    this.refreshTree()
  }


  returnChangesFilters($event){
    this.composedEditForm.patchValue({filter: $event.newFilters})
  }

  returnChangesStyle($event){
    this.composedEditForm.patchValue({widgetStyle: $event.newStyle})
  }

}
